<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-8 text-center mb-4">
        <h1 class="text-success text-center pb-4 border-bottom">Complete</h1>
        <p class="text-navy mt-4">
          Setup complete. Thank you for taking the time to provide us with this
          information.
        </p>
        <p class="text-navy">
          We will be in touch shortly with the onboarding documents for
          e-signature. Please keep an eye on your emails for these.
        </p>
        <p class="text-navy">
          If you have any questions in the meantime please do not hesitate to
          contact our office on <strong>02 6750 9400</strong> or email
          <strong>admin@otleycapital.com</strong>
        </p>
      </div>
      <div class="col-8 text-center">
        <el-button
          class="btn-primary py2 px-4 text-uppercase"
          v-if="profile_type_id == 1"
          @click="addProducer"
        >
          Add producer
        </el-button>
      </div>
    </div>
    <div class="pt-4 mt-4"></div>
    <div
      class="px-5 pb-4"
      style="position: absolute; bottom: 0; left: 0; right: 0"
    >
      <div>
        <el-button class="btn-secondary" @click="updateLead('prev')">
          Previous
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    profile_type_id: {
      type: Number,
    },
    initial_lead: {
      type: Object,
    },
    onboardingAccount: {
      type: Object,
    },
  },
  methods: {
    addProducer() {
      this.$emit("create-lead");
    },
    updateLead(step) {
      this.$emit("update-lead", this.initial_lead, step);
    },
  },
};
</script>
